import Styled from 'styled-components';

import { ICheckboxContain } from './common';
import { CheckboxBackgroundStyles } from './CheckboxBackgroundStyles';

export const CheckboxBackground = Styled.div<ICheckboxContain>`
  ${CheckboxBackgroundStyles}
`;
